export type ThemeMode = "light" | "dark";

const STORAGE_KEY = "tripPlanner.theme";

function systemPreference(): ThemeMode {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

class Theme extends EventTarget {
  private mode: ThemeMode;

  constructor() {
    super();
    const saved = localStorage.getItem(STORAGE_KEY);
    this.mode = saved === "dark" || saved === "light" ? saved : systemPreference();
    this.apply();
  }

  current(): ThemeMode {
    return this.mode;
  }

  set(mode: ThemeMode): void {
    if (mode === this.mode) return;
    this.mode = mode;
    localStorage.setItem(STORAGE_KEY, mode);
    this.apply();
    this.dispatchEvent(new Event("change"));
  }

  toggle(): void {
    this.set(this.mode === "dark" ? "light" : "dark");
  }

  private apply(): void {
    document.documentElement.dataset.theme = this.mode;
  }
}

// Applied at module load, before initSidebar wires the toggle button — avoids a
// light-mode flash on a dark-preferring system.
export const theme = new Theme();
